import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./assets/styles/app.scss";
import * as serviceWorkerRegistration from "./services/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (window.confirm("New version available. Reload now?")) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }

      window.location.reload();
    }
  },
});